import { render } from "./timer.html?vue&type=template&id=5bd186ec&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"

import "./timer.scss?vue&type=style&index=0&id=5bd186ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bd186ec"

export default script